export default "__VITE_ASSET__BnqwvPug__"